import apiClient from '../../client'
import type {
  ConsentTemplateListItem,
  ConsentTemplateDetail,
  UpdateConsentTemplateRequest,
} from '../../models/consentTemplate.models'

const BASE_PATH = '/maestros/consent-templates'

export const consentTemplateService = {
  async getAll(): Promise<ConsentTemplateListItem[]> {
    return apiClient.get<ConsentTemplateListItem[]>(BASE_PATH)
  },
  async getById(id: string): Promise<ConsentTemplateDetail> {
    return apiClient.get<ConsentTemplateDetail>(`${BASE_PATH}/${id}`)
  },
  async createDraft(): Promise<ConsentTemplateDetail> {
    return apiClient.post<ConsentTemplateDetail>(`${BASE_PATH}/draft`)
  },
  async update(id: string, data: UpdateConsentTemplateRequest): Promise<ConsentTemplateDetail> {
    return apiClient.put<ConsentTemplateDetail, UpdateConsentTemplateRequest>(`${BASE_PATH}/${id}`, data)
  },
  async publish(id: string): Promise<ConsentTemplateDetail> {
    return apiClient.post<ConsentTemplateDetail>(`${BASE_PATH}/${id}/publish`)
  },
  async delete(id: string): Promise<boolean> {
    return apiClient.delete<boolean>(`${BASE_PATH}/${id}`)
  },
}
